import apiClient from './apiClient';

export const getAccounts = (params = {}) => {
  return apiClient.get(`/accounts`, {
    params: params,
  });
};

export const getAccount = (id) => {
  return apiClient.get(`/accounts/${id}`);
};

export const saveAccount = (data) => {
  return apiClient.post("/accounts", data);
};

export const updateAccount = (data, id) => {
  return apiClient.put(`/accounts/${id}`, data);
};

export const deleteAccount = (id) => {
  return apiClient.delete(`/accounts/${id}`);
};

export const bulkDeleteAccounts = (ids) => {
  return apiClient.post("/accounts/bulk-delete", { ids });
};

export const getAccountUrls = () => {
  return apiClient.get("/accounts/urls");
};
